import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useTokenStore = defineStore('token', () => {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  const token = params.csToken || localStorage.getItem('rqdCsToken');
  const csToken = ref(token || '');
  const editToken = ref(false);

  function setCsToken(token: string) {
    csToken.value = token;
    localStorage.setItem('rqdCsToken', token);
    editToken.value = false;
  }

  return { csToken, editToken, setCsToken };
});
